import ninegrid from "../index.js";

class nxTopMenu extends HTMLElement
{
	constructor() {
		super();
		this.attachShadow({ mode: 'open' });
	}
	
	connectedCallback() {
	
		this.shadowRoot.innerHTML = `
			<style>
				:host {
					display: flex;
					background-color: #444;
				    height: 60px;
				    width: 100%;
				    position: fixed;
					top: 0;
				    z-index: 1001;
					overflow: hidden;
				}
				
				.logo {
					display: none;
				}
				nav {
					display: flex;
					width: 100%;
					overflow: hidden;
				}
			</style>


				<div class="logo">
					<!-- Logo Header -->
					<div class="logo-header">
						<a href="/" class="logo">
							<h5 class="text-white">nine-grid</h5>
						</a>
						<div class="nav-toggle">
							<button class="btn btn-toggle toggle-sidebar">
								<i class="gg-menu-right"></i>
							</button>
							<button class="btn btn-toggle sidenav-toggler">
								<i class="gg-menu-left"></i>
							</button>
						</div>
						<button class="topbar-toggler more">
							<i class="gg-more-vertical-alt"></i>
						</button>
					</div>
					<!-- End Logo Header -->
				</div>
				
				<!-- Navbar Header -->
				<nav>
					<div>
						<a href="/css/nine-grid.zip" style="color:#ccc;">css download</a>
					</div>
					<ul class="navbar-nav topbar-nav ms-md-auto align-items-center" style="flex-direction: column; align-items: flex-end !important;">
						<li class="nav-item dropdown">
							<button type="button" class="btn btn-link nav-link py-2 px-0 px-lg-2 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" data-bs-display="static">
								<span class="d-lg-none" aria-hidden="true">Bootstrap</span><span class="visually-hidden">Bootstrap&nbsp;</span><span id="locale">한국어</span><span class="visually-hidden">(switch to other versions)</span>
							</button>
							<ul class="dropdown-menu dropdown-menu-end">
								<li><h6 class="dropdown-header">language</h6></li>
								<li>
									<a class="dropdown-item" href="#" onclick="this.closest('top-menu').changeLocale('ko')">한국어</a>
								</li>
								<li>
									<a class="dropdown-item" href="#" onclick="this.closest('top-menu').changeLocale('en')">English</a>
								</li>
							</ul>
						</li>
						<li class="nav-item contact">
							<nobr><span class="m-0" style="color:#999;">Meet the best team.</span> <span style="color:#999;">contact </span> <span style="color:#bbb;">nandoo@hanmail.net</span>
						</li>
					</ul>
				</nav>
		`;
		
		this.changeLocale(ninegrid.getLocale());
	};
	
	changeLocale = (locale) => {
		ninegrid.setLocale(locale);
		this.shadowRoot.querySelector("#locale").innerHTML = ninegrid.decode(locale, "ko", "한국어", "English");
	};
}

if (!customElements.get('nx-top-menu')) {
	customElements.define("nx-top-menu", nxTopMenu);
}
